import { useState } from "react";
import ProgressBar from "./pages/ProgressBar";
import "./App.css";
import { ConfigProvider, Slider } from "antd";
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import { AiOutlineQuestionCircle } from "react-icons/ai"
import leading from '../src/assets/images/leading.png'

function App() {
  const [sVolume, setSVolume] = useState(1000); // Set your initial value here
  const [ctr, setCtr] = useState(10); // Set your initial value here
  const [cRate, setCRate] = useState(20); // Set your initial value here
  const [aoValue, setAOValue] = useState(10); // Set your initial value here
  const [ltValue, setLTValue] = useState(100);// Set your initial value here

  const borderBottomStyle = {
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '8px',
    paddingTop: '8px' // Adjust the color as needed
  };




  const onChangeSVolume = (value) => {
    setSVolume(value)
  };
  const onChangeCtr = (value) => {
    setCtr(value)
  };
  const onChangeCRate = (value) => {
    setCRate(value)
  };
  const onChangeAoValue = (value) => {
    setAOValue(value)
  };
  const onChangeLtValue = (value) => {
    setLTValue(value)
  };
  return (
    <div className="w-11/12 mx-auto grid grid-cols-1 lg:grid-cols-2 mt-12 shadow-lg">

      <div>
        <div className="grid grid-cols-12 w-full mb-3 lg:mb-0 border border-1 border-[#01E86F] lg:border-gray-200 mx-auto">
          <div className="col-span-12 lg:col-span-4 p-3">
            <p className="text-black">
              How many searches do you get for keywords related to your business? (per month)
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8 border border-1 p-3">
            {/* <ProgressBar className="w-full" value={value} /> */}
            <div className="flex justify-between items-center">
              <div className="flex justify-left items-center">
                <h5 className="text-[#01E86F] text-md">Search Volume</h5>
                <a className="lg:border lg:border-1 rounded-full" data-tooltip-id="my-tooltip"
                  data-tooltip-content="? You can find your Search Volume on your Google Analytics/Google Search Console,
                  or other online tools such as Aherfs,SEMrush and Moz"> <AiOutlineQuestionCircle className="text-black" /></a>
              </div>
              <p className="text-[#01E86F] font-bold">{sVolume}</p>
              <Tooltip
                style={{ maxWidth: '170px' }}
                place="right"
                type="info"
                effect="solid"
                multiline={true}
                delayShow={500}
                delayHide={100}
                id="my-tooltip" />
            </div>
            <div className="flex justify-left items-center">
              <ConfigProvider
                theme={{
                  components: {
                    Slider: {
                      railSize: 8,
                      trackBg: '#01E86F',
                      trackHoverBg: '#01E86F',
                      railBg: '#D5D5D5',
                      railHoverBg:'#D5D5D5',
                      handleSize: 16,
                      handleSizeHover:16,
                      handleColor: 'white',
                      dotBorderColor: '#D5D5D5',
                      dotActiveBorderColor: '#D5D5D5',
                      handleLineWidth: 1,
                      handleLineWidthHover: 1,
                      handleColor: '#D5D5D5',
                      handleActiveColor: '#D5D5D5',

                      /* here is your component tokens */
                    },
                  },
                }}
              >
                <Slider
                  min={100}
                  max={10000}
                  step={100}
                  onChange={onChangeSVolume}
                  className="w-60 lg:w-80"
                  value={sVolume}
                />

              </ConfigProvider>

            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 w-full mb-3 lg:mb-0 border border-1 border-[#01E86F] lg:border-gray-200 mx-auto">
          <div className="col-span-12 lg:col-span-4 p-3">
            <p className="text-black">
              What percentage of people searching for your keywords click on your website?
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8 lg:border lg:border-1 p-3">
            {/* <ProgressBar className="w-full" value={value} /> */}
            <div className="flex justify-between">
              <div className="flex justify-left items-center">
                <h5 className="text-[#01E86F] text-md">CTR</h5>
                <a className="lg:border lg:border-1 rounded-full" data-tooltip-id="my-tooltip"
                  data-tooltip-content="If you receive 20 clicks monthly over 1.000 of Search Volume 
                  for one keyword, then your click through rate equals to (200/1000)% = 20%"> <AiOutlineQuestionCircle className="text-black" /></a>
              </div>
              <p className="text-[#01E86F] font-bold">{ctr}%</p>
              <Tooltip
                style={{ maxWidth: '170px' }}
                place="right"
                type="info"
                effect="solid"
                multiline={true}
                delayShow={500}
                delayHide={100}
                id="my-tooltip" />
            </div>
            <div className="flex justify-left items-center">
            <ConfigProvider
                theme={{
                  components: {
                    Slider: {
                      railSize: 8,
                      trackBg: '#01E86F',
                      trackHoverBg: '#01E86F',
                      railBg: '#D5D5D5',
                      railHoverBg:'#D5D5D5',
                      handleSize: 16,
                      handleSizeHover:16,
                      handleColor: 'white',
                      dotBorderColor: '#D5D5D5',
                      dotActiveBorderColor: '#D5D5D5',
                      handleLineWidth: 1,
                      handleLineWidthHover: 1,
                      handleColor: '#D5D5D5',
                      handleActiveColor: '#D5D5D5',

                      /* here is your component tokens */
                    },
                  },
                }}
              >
              <Slider
                min={5}
                max={100}
                step={5}
                value={10}
                onChange={onChangeCtr}
                className="w-60 lg:w-80"
                value={ctr} />
                </ConfigProvider>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 w-full mb-3 lg:mb-0 border border-1 border-[#01E86F] lg:border-gray-200 mx-auto">
          <div className="col-span-12 lg:col-span-4 p-3">
            <p className="text-black">
              What percentage of the visitors to your website convert into customers?
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8 lg:border lg:border-1 p-3">
            {/* <ProgressBar className="w-full" value={value} /> */}
            <div className="flex justify-between">
              <div className="flex justify-left items-center">
                <h5 className="text-[#01E86F] text-md">Conversion Rate</h5>
                <a className="lg:border lg:border-1 rounded-full" data-tooltip-id="my-tooltip"
                  data-tooltip-content="If 50 out of 500 traffic convert into customers, your conversion rate is (50/500)% = 10%"> <AiOutlineQuestionCircle className="text-black" /></a>
              </div>
              <p className="text-[#01E86F] font-bold">{cRate}%</p>
              <Tooltip
                style={{ maxWidth: '170px' }}
                place="right"
                type="info"
                effect="solid"
                multiline={true}
                delayShow={500}
                delayHide={100}
                id="my-tooltip" />
            </div>
            <div className="flex justify-left items-center">
            <ConfigProvider
                theme={{
                  components: {
                    Slider: {
                      railSize: 8,
                      trackBg: '#01E86F',
                      trackHoverBg: '#01E86F',
                      railBg: '#D5D5D5',
                      railHoverBg:'#D5D5D5',
                      handleSize: 16,
                      handleSizeHover:16,
                      handleColor: 'white',
                      dotBorderColor: '#D5D5D5',
                      dotActiveBorderColor: '#D5D5D5',
                      handleLineWidth: 1,
                      handleLineWidthHover: 1,
                      handleColor: '#D5D5D5',
                      handleActiveColor: '#D5D5D5',

                      /* here is your component tokens */
                    },
                  },
                }}
              >
              <Slider
                min={0.5}
                max={100}
                step={0.5}
                onChange={onChangeCRate}
                className="w-60 lg:w-80"
                value={cRate} />
                </ConfigProvider>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 w-full mb-3 lg:mb-0 border border-1 border-[#01E86F] lg:border-gray-200 mx-auto">
          <div className="col-span-12 lg:col-span-4  p-3">
            <p className="text-black">
              What is your average order value?
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8 lg:border lg:border-1 p-3">
            {/* <ProgressBar className="w-full" value={value} /> */}
            <div className="flex justify-between">
              <div className="flex justify-left items-center">
                <h5 className="text-[#01E86F] text-md">Average order value</h5>
                <a className="lg:border lg:border-1 rounded-full" data-tooltip-id="my-tooltip"
                  data-tooltip-content="You can calculate your Average Order Value using
                   the equation of dividing total revenue by number of orders."> <AiOutlineQuestionCircle className="text-black" /></a>
              </div>
              <p className="text-[#01E86F] font-bold">€{aoValue}</p>
              <Tooltip
                style={{ maxWidth: '170px' }}
                place="right"
                type="info"
                effect="solid"
                multiline={true}
                delayShow={500}
                delayHide={100}
                id="my-tooltip" />
            </div>
            <div className="flex justify-left items-center">
            <ConfigProvider
                theme={{
                  components: {
                    Slider: {
                      railSize: 8,
                      trackBg: '#01E86F',
                      trackHoverBg: '#01E86F',
                      railBg: '#D5D5D5',
                      railHoverBg:'#D5D5D5',
                      handleSize: 16,
                      handleSizeHover:16,
                      handleColor: 'white',
                      dotBorderColor: '#D5D5D5',
                      dotActiveBorderColor: '#D5D5D5',
                      handleLineWidth: 1,
                      handleLineWidthHover: 1,
                      handleColor: '#D5D5D5',
                      handleActiveColor: '#D5D5D5',

                      /* here is your component tokens */
                    },
                  },
                }}
              >
              <Slider
                min={10}
                max={10000}
                step={10}
                onChange={onChangeAoValue}
                className="w-60 lg:w-80"
                value={aoValue} />
                </ConfigProvider>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-12 w-full mb-3 lg:mb-0 border border-1 border-[#01E86F] lg:border-gray-200 mx-auto">
          <div className="col-span-12 lg:col-span-4 lg:border lg:border-1 p-3">
            <p className="text-black">
              What is your average customer lifetime value?
            </p>
          </div>
          <div className="col-span-12 lg:col-span-8 lg:border lg:border-1 p-3">
            {/* <ProgressBar className="w-full" value={value} /> */}
            <div className="flex justify-between">
              <div className="flex justify-left items-center">
                <h5 className="text-[#01E86F] text-md">Lifetime value</h5>
                <a className="lg:border lg:border-1 rounded-full" data-tooltip-id="my-tooltip"
                  data-tooltip-content="Suppose you’re not in touch with your customer lifetime value,
                  calculate it by multiplying your customer with their average lifetime."> <AiOutlineQuestionCircle className="text-black" /></a>
              </div>
              <p className="text-[#01E86F] font-bold">€{ltValue}</p>
              <Tooltip
                style={{ maxWidth: '170px' }}
                place="right"
                type="info"
                effect="solid"
                multiline={true}
                delayShow={500}
                delayHide={100}
                id="my-tooltip" />
            </div>
            <div className="flex justify-left items-center">
            <ConfigProvider
                theme={{
                  components: {
                    Slider: {
                      railSize: 8,
                      trackBg: '#01E86F',
                      trackHoverBg: '#01E86F',
                      railBg: '#D5D5D5',
                      railHoverBg:'#D5D5D5',
                      handleSize: 16,
                      handleSizeHover:16,
                      handleColor: 'white',
                      dotBorderColor: '#D5D5D5',
                      dotActiveBorderColor: '#D5D5D5',
                      handleLineWidth: 1,
                      handleLineWidthHover: 1,
                      handleColor: '#D5D5D5',
                      handleActiveColor: '#D5D5D5',

                      /* here is your component tokens */
                    },
                  },
                }}
              >
              <Slider
                min={100}
                max={10000}
                step={100}
                onChange={onChangeLtValue}
                className="w-60 lg:w-80"
                value={ltValue}
              />
              </ConfigProvider>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#01E86F] p-5">
        <div>
          {/* <img src={leading} className="w-3/4 mx-auto" alt="" /> */}
          <h3 className="text-white text-center font-bold mb-8">Based On These Figures, Here Is What You Could Expect For Return On Investment*</h3>

          <div style={borderBottomStyle} className="flex justify-between border-b-1 text-white">
            <p>Traffic</p>
            <p>{(sVolume / 100) * ctr}</p>
          </div>
          <div style={borderBottomStyle} className="flex justify-between border-b-1 text-white">
            <p>Conversion</p>
            <p>{Math.ceil((ctr / 100 * cRate) * (sVolume / 100))}</p>
          </div>
          <div style={borderBottomStyle} className="flex justify-between border-b-1 text-white">
            <p>AOV</p>
            <p>€{aoValue}</p>
          </div>
          <div style={borderBottomStyle} className="flex justify-between border-b-1 text-white">
            <p>Net Revenue (Monthly)</p>
            <p>€{Math.ceil((ctr / 100 * cRate) * (sVolume / 100) * aoValue)}</p>
          </div>
          <div style={borderBottomStyle} className="flex justify-between border-b-1 text-white">
            <p>Total Lifetime Value</p>
            <p>€{Math.ceil((((ctr / 100 * cRate) * (sVolume / 100) * aoValue) / (aoValue / 100)) * ltValue / 100)}</p>
          </div>

          <div className="flex justify-between text-white mt-4">
            <h1 className="text-xl">Monthly ROI</h1>
            <div className="flex flex-col">
              <p className="text-xl">€{Math.ceil((ctr / 100 * cRate) * (sVolume / 100) * aoValue)}</p>
              {/* <p>(≈{((ctr / 100 * cRate) * (sVolume / 100) * aoValue) / 0.000038} ₫)</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}





export default App;


// import React, { useState } from 'react';
// import { Slider, Switch } from 'antd';
// const App = () => {
//   const [disabled, setDisabled] = useState(false);
//   const onChange = (checked) => {
//     setDisabled(checked);
//   };
//   return (
//     <>
//       <Slider defaultValue={30} disabled={disabled} />
//       <Slider range defaultValue={[20, 50]} disabled={disabled} />
//       Disabled: <Switch size="small" checked={disabled} onChange={onChange} />
//     </>
//   );
// };
// export default App;
